
import {
  Row, 
} from 'reactstrap';
import { Link } from 'react-router-dom';


import './style.css';

export default function Mapeo() {


  return (
    <div className="contentSimple"  >
      <div className="main-container">
        <h1 className='text-center mt-2'>MAPA DE INFESTACION ENTOMOLOGICA</h1>
          <div
            style={{ height: '80vh' }}>
            <div style={{ position: 'relative', top: '25vh' }}>

              <p className='mb-5 text-center' style={{ color: "#fd5d93", fontWeight: '600' }} >Presione en una opcion</p>
              <Row style={{ display: 'flex', justifyContent: 'space-around' }}>
                <Link to={'/maps-entomologico'}  className='botonMainMaps' style={{ background: '#fd5d93' }}>
                  Mapa Epidemiológico
                </Link>
                <Link to={'/maps-entomologico'} className='botonMainMaps' style={{ background: '#00AEA4 ' }}>
                  Mapa Estratificado
                </Link>
              </Row>
            </div>
          </div>
          
      </div>
    </div>
  );
}